<div class="flex flex-col gap-1">
    <a [attr.href]="historyUrl" class="text-sm w-full flex flex-row items-center gap-2 group bg-slate-50 p-1 min-h-8 rounded shadow-sm border border-transparent"
        [ngClass]="{ 'stroke-ponder-light hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer hover:border-ponder-link' : historyUrl, 'text-slate-400 stroke-slate-400 hover:cursor-default' : !historyUrl }"
        [attr.title]="historyUrl ? null : 'Login to see this card in your collection history.'">
        <div class="flex justify-end pl-2">
            <svg class="w-6 h-6 fill-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1">
                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="clockSvgIcon" />
            </svg>
        </div>
        <div>
            See in Collection History
        </div>
    </a>
    <a [attr.href]="gathererUrl" class="text-sm w-full flex flex-row items-center gap-2 group bg-slate-50 p-1 min-h-8 rounded shadow-sm border border-transparent"
        [ngClass]="{ 'fill-ponder-light hover:text-ponder-link hover:fill-ponder-link hover:cursor-pointer hover:border-ponder-link' : gathererUrl, 'text-slate-400 fill-slate-400 hover:cursor-default' : !gathererUrl }">
        <div class="flex justify-end pl-2">
            <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 100" stroke-width="1">
                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="magicSvgIcon" ></path>
            </svg>
        </div>
        <div class="col-span-2">
            See on Gatherer
        </div>
    </a>
    <a [attr.href]="scryfallUrl" class="text-sm w-full flex flex-row items-center gap-2 group bg-slate-50 p-1 min-h-8 rounded shadow-sm border border-transparent"
        [ngClass]="{ 'fill-ponder-light hover:text-ponder-link hover:fill-ponder-link hover:cursor-pointer hover:border-ponder-link' : scryfallUrl, 'text-slate-400 fill-slate-400 hover:cursor-default' : !scryfallUrl }">
        <div class="flex justify-end pl-2">
            <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 460 460" stroke-width="1">
                <g transform="translate(-60 -58)" fill-rule="evenodd">
                    <path [attr.d]="scryfallSvgIcon" ></path></g>
            </svg>
        </div>
        <div class="col-span-2">
            See on Scryfall
        </div>
    </a>
    <a [attr.href]="tcgPlayerUrl" class="text-sm w-full flex flex-row items-center gap-2 group bg-slate-50 p-1 min-h-8 rounded shadow-sm border border-transparent"
        [ngClass]="{ 'stroke-ponder-light hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer hover:border-ponder-link' : tcgPlayerUrl, 'text-slate-400 stroke-slate-400 hover:cursor-default' : !tcgPlayerUrl }">
        <div class="flex justify-end pl-2">
            <svg class="w-6 h-6 fill-none" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 20 20" stroke-width="1">
                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="tcgplayerSvgIcon" />
            </svg>
        </div>
        <div>
            See on TCGplayer
        </div>
    </a>
</div>